export function MapGoalDirection(input: string): boolean | undefined {
	switch (input) {
		case '':
			return undefined;

		case 'Up':
			return true;

		case 'Down':
			return false;

		default:
			return undefined;
	}
}
